import { render, staticRenderFns } from "./DemandChart.vue?vue&type=template&id=3525eb5c&scoped=true"
import script from "./DemandChart.vue?vue&type=script&lang=js"
export * from "./DemandChart.vue?vue&type=script&lang=js"
import style0 from "./DemandChart.vue?vue&type=style&index=0&id=3525eb5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3525eb5c",
  null
  
)

export default component.exports